import type { Asserts } from 'yup';

import { contractSchema as nutzContractSchema } from '@/features/Sparten/nutz/schema/contractSchema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const contractSchema = nutzContractSchema;

export type ContractStore = Asserts<typeof contractSchema>;

export const useNutzContractStore = genericStoreFactory(
  () => contractSchema.getDefault() as ContractStore,
  'NutzContractStore',
);
